<style scoped>
  .box1 {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    margin-right: 20px;
    padding: 20px;
    border: 1px solid azure;
  }

  body, html {
    height: 100%;
    background-color: indianred;
  }

  /*html {*/
  /*background: url(images/bg.jpg) no-repeat center center fixed;*/
  /*-webkit-background-size: cover;*/
  /*-moz-background-size: cover;*/
  /*-o-background-size: cover;*/
  /*background-size: cover;*/
  /*}*/

  .bg {
    height: 100vh;
    /*background-color: dimgray;*/
    background-image: url("../../assets/bglogin.jpg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .container {
    position: absolute;
    top: 45%;
    left: 50%;
    -moz-transform: translateX(-50%) translateY(-55%);
    -webkit-transform: translateX(-50%) translateY(-55%);
    transform: translateX(-50%) translateY(-55%);
    /*border: 1px solid indianred;*/
    padding: 20px;
    opacity: 0.7;
    background-color: #39317e;
    width: 420px;
    height: 240px;
    border-radius: 20px;
  }

  /*div {*/
  /*border: 1px solid indianred;*/
  /*}*/

  a:hover {
    color: azure;
    text-decoration: underline;
  }

  a {
    color: azure;
  }

  .shad {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }

  .container {
    --color-text-light: #ffffff;
    --color-text: #e6e6e6;
    --color-text-dark: #787bb4;
    --color-input: #2a2f44;
    --color-input-shadow: rgba(255, 255, 255, 0.2);
    --color-neutral-light: #cbcbcb;
  }

</style>
<template>
  <div class="bg" style="text-align: center;">
    <img alt=""
         src="@/assets/logo.png"
         style="width: 160px; margin-top: 20px;">
    <div v-if="!newpwd">
      <div v-if="!success" class="container box shad">
        <!--<form @submit.prevent="login">-->
        <div style="color: white; font-size: 20px;">{{ $text.tr('ЗАБЫЛИ ПАРОЛЬ?') }}</div>
        <div style="height: 20px;margin-top: 0px; color: indianred; text-align: center;">
          <transition name="fade">
            <span v-if="error">{{ errText }}</span>
          </transition>
        </div>
        <i-input v-model="email" type="text" size="large" style="width: 340px; margin-top: 10px;"
               placeholder="email"></i-input><br><br><br/>
        <Button size="large" long style="width: 340px;" @click="forgot">{{ $text.tr('Сменить пароль') }}</Button>
        <!--<button type="submit">Войти</button>-->
        <!--</form>-->

      </div>
      <div v-if="success" class="container box shad" style="color: azure; font-size: 16px; display: flex; align-items: center; justify-content: center;">
        {{ $text.tr('На ваш email отправлено письмо с инструкциями') }}
      </div>
    </div>
    <div v-if="newpwd">
      <div v-if="!success" class="container box shad">
        <!--<form @submit.prevent="setnewpwd">-->
        <div style="height: 20px;margin-top: 0px; color: indianred; text-align: center;">
          <transition name="fade">
            <span v-if="error">{{ errText }}</span>
          </transition>
        </div>
        <!--<input v-model="email" type="hidden"></input><br>-->
        <i-input v-model="passwd" type="password" size="large" style="width: 340px; margin-top: 10px;"
               :placeholder="$text.tr('новый пароль')"></i-input><br>
        <i-input v-model="passwd2" type="password" size="large" style="width: 340px; margin-top: 10px;"
               :placeholder="$text.tr('подтверждение пароля')"></i-input><br><br>
        <Button size="large" long style="width: 340px;"  @click="setnewpwd">{{ $text.tr('Установить пароль') }}</Button>
        <!--<Button size="large" style="width: 300px;" type="submit">Установить пароль</Button>-->
        <!--<button type="submit">Установить пароль</button>-->
        <!--</form>-->

      </div>
      <div v-if="success" class="container box shad" style="color: azure; font-size: 16px; display: flex; align-items: center; justify-content: center;">
        {{ $text.tr('Успешно!') }}<br>{{ $text.tr('На ваш email отправлено письмо с инструкциями') }}
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/util/api'
import Util from '@/util/util'
import { sha256 } from 'js-sha256'
import Apis from '@/util/apis'
import Constants from '@/util/constants'

export default {
  name: 'Login',
  data: function () {
    return {
      email: '',
      passwd: '',
      passwd2: '',
      error: false,
      errText: '',
      success: false,
      newpwd: false
    }
  },
  created () {
    // alert(1)
    if (this.$route.params.ctok !== undefined) {
      this.newpwd = true
      // this.email = localStorage.getItem('newpwdemail')
    }
  },
  methods: {
    setnewpwd () {
      if (this.passwd.length < 6) {
        this.error = true
        this.errText = this.$text.tr('Пароль минимум 6 символов')
        setTimeout(() => {
          this.error = false
        }, 3000)
        return
      }

      if (this.passwd !== this.passwd2) {
        this.error = true
        this.errText = this.$text.tr('Пароли не совпадают')
        setTimeout(() => {
          this.error = false
        }, 3000)
        return
      }
      const pwdhash = sha256(this.passwd)
      Api
        .get('changepwd?ctok=' + this.$route.params.ctok + '&pwdh=' + pwdhash)
        .then(response => {
          // console.log(response.data)
          if (response.data.err !== undefined) {
            this.$Message.error(this.$text.tr('Ошибка') + ': ' + Util.returnTextForErr(response.data.err))
          } else {
            // this.success = true

            // this.$Message.success(response.data.token)

            const tok = response.data.token
            Api
              .get('user/info?token=' + tok)
              .then(async response => {
                // console.log(response)
                this.$store.state.sys.token = tok
                localStorage.setItem('token', tok)
                this.$store.state.sys.email = response.data.Email

                try {
                  const respsg = await Apis.sg.get('user/info?token=' + tok)
                  if (respsg.status === Constants.http.OK) {
                    respsg.data.exchanges.forEach(exch => {
                      exch.sptnk = 'sg'
                      response.data.exchanges.push(exch)
                    })
                  }
                  response.data.exchanges.sort((a, b) => (a.Name.toLowerCase() < b.Name.toLowerCase()) ? -1 : ((b.Name.toLowerCase() > a.Name.toLowerCase()) ? 1 : 0))
                } catch (err) {
                  console.log(err)
                }

                this.$store.state.sys.allexchanges = response.data.exchanges
                this.$store.state.sys.exchanges = []
                response.data.exchanges.forEach(exch => {
                  if (exch.Demo === this.$store.state.sys.demo) {
                    this.$store.state.sys.exchanges.push(exch)
                  }
                })

                this.$router.replace('/')
              })
              .catch(error => {
                console.log(error.response)
                this.$Message.error(this.$text.tr('Ошибка') + ': ' + Util.returnTextForErr(error.response.data))
              })

            // this.$store.state.token = tok
            // localStorage.setItem('token', tok)
            // this.$store.state.email = response.data.Email
            // this.$store.s  tate.exchanges = response.data.exchanges
            // this.$router.push('/')
          }
        })
        .catch(error => {
          console.log(error.response)
          // console.log(error)
          // this.error = true
          // setTimeout(() => {
          //   this.error = false
          // }, 3000)
        })
    },
    forgot () {
      // localStorage.setItem('newpwdemail', this.email)
      const x = sha256('V1c5QraZkYkA' + this.email.trim().toLowerCase()).substr(0, 6)
      Api
        .get('forgotpwd?email=' + this.email.trim().toLowerCase() + '&x=' + x)
        .then(response => {
          if (response.data.err !== undefined) {
            // this.$Message.error('Ошибка: ' + response.data.err)
            if (response.data.err === 'user isn\'t registered') {
              this.errText = this.$text.tr('Такой пользователь не существует')
            }
            this.error = true
            setTimeout(() => {
              this.error = false
            }, 3000)
          } else {
            this.success = true
          }
        })
        .catch(error => {
          console.log(error.response)
          this.error = true
          setTimeout(() => {
            this.error = false
          }, 3000)
        })

      /*
      if (this.email === '1' && this.passwd === '1') {
        this.error = false

        // this.$store.state.token = ''
        // localStorage.setItem('token')
        this.$router.push('/')
      } else {
        var tok = sha256(this.email + this.passwd)
        */
    }
  }
}
</script>
